import { Text, TextProps } from '@mantine/core';

import type { PublishedAt } from '@feature/utils';

export interface PublishedAtProps extends TextProps {
  date: PublishedAt | null;
}

function format(date: PublishedAt) {
  if (date.month == null) {
    return date.year;
  }

  return `${date.month}.${date.year}`;
}

export function PublishedAtText(props: PublishedAtProps) {
  const { date, ...textProps } = props;

  if (date == null) return null;

  return <Text {...textProps}>{format(date)}</Text>;
}
